import React, { useEffect, useState } from "react";
import axios from "axios";
import { useSearchParams } from "react-router-dom";
import { MdDelete } from "react-icons/md";
import { RiPencilFill } from "react-icons/ri";
import { useAlert } from "../../alert/Alert_message";
import ConfirmationModal from "../../alert/Conform_alert";

const Groupage_items = () => {
  const port = process.env.REACT_APP_SECRET;
  const token = localStorage.getItem("token");
  const userRole = localStorage.getItem("userRole");

  const { showAlert } = useAlert();

  const [isMobile, setIsMobile] = useState(window.innerWidth < 800);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 800);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const [items, setItems] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);

  const [showAddModal, setShowAddModal] = useState(false);
  const [editMode, setEditMode] = useState(false);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteItem, setDeleteItem] = useState(null);

  const [formData, setFormData] = useState({
    id: null,
    categories_fr: "",
    categories_en: "",
    object_fr: "",
    object_en: "",
    volume: "",
    price: "",
  });

  const [searchParams, setSearchParams] = useSearchParams();

  const currentPage = Number(searchParams.get("page")) || 1;
  const searchFromUrl = searchParams.get("search") || "";

  const [searchInput, setSearchInput] = useState(searchFromUrl);

  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);

  const fetchGroupageItems = async () => {
    if (userRole !== "Sadmin") return;

    try {
      const params = new URLSearchParams();

      params.append("page", currentPage);

      if (searchFromUrl) {
        params.append("search", searchFromUrl);
      }

      const response = await axios.get(
        `${port}/s_admin/groupage_items?${params.toString()}`,
        {
          headers: {
            Authorization: token,
          },
        },
      );

      if (response.data.status) {
        setItems(response.data.message || []);

        setTotalPages(response.data.pagination?.totalPages || 1);

        setTotalItems(response.data.pagination?.totalItems || 0);
      } else {
        setItems([]);
        setTotalPages(1);
        setTotalItems(0);
      }
    } catch (error) {
      console.log("Error fetching groupage items:", error);

      setItems([]);
      setTotalPages(1);
      setTotalItems(0);
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();

    const params = new URLSearchParams();

    if (searchInput.trim()) {
      params.set("search", searchInput.trim());
    }

    params.set("page", "1");

    setSearchParams(params);
  };

  const handleClearSearch = () => {
    setSearchInput("");

    const params = new URLSearchParams();
    params.set("page", "1");

    setSearchParams(params);
  };

  useEffect(() => {
    setSearchInput(searchFromUrl);
    fetchGroupageItems();
  }, [currentPage, searchFromUrl]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => {
      const updatedData = {
        ...prev,
        [name]: value,
      };

      // Price = volume * 600
      if (name === "volume") {
        const volume = Number(value);

        if (value === "" || isNaN(volume)) {
          updatedData.price = "";
        } else {
          updatedData.price = volume * 600;
        }
      }

      return updatedData;
    });
  };

  const openAddModal = () => {
    setEditMode(false);

    setFormData({
      id: null,
      categories_fr: "",
      categories_en: "",
      object_fr: "",
      object_en: "",
      volume: "",
      price: "",
    });

    setShowAddModal(true);
  };

  const closeAddModal = () => {
    setShowAddModal(false);

    setEditMode(false);

    setFormData({
      id: null,
      categories_fr: "",
      categories_en: "",
      object_fr: "",
      object_en: "",
      volume: "",
      price: "",
    });
  };

  const handleAddItem = async () => {
    if (
      !formData.categories_fr ||
      !formData.categories_en ||
      !formData.object_fr ||
      !formData.object_en ||
      formData.volume === ""
    ) {
      showAlert("Please fill all required fields");

      return;
    }

    try {
      const response = await axios.post(
        `${port}/s_admin/groupage_items/create`,
        {
          categories_fr: formData.categories_fr,
          categories_en: formData.categories_en,
          object_fr: formData.object_fr,
          object_en: formData.object_en,
          volume: Number(formData.volume),
          price: Number(formData.volume) * 600,
        },
        {
          headers: {
            Authorization: token,
          },
        },
      );

      if (response.data.status) {
        showAlert(response.data.message);

        closeAddModal();

        fetchGroupageItems();
      } else {
        showAlert(response.data.message || "Unable to create item");
      }
    } catch (error) {
      console.log("Error creating groupage item:", error);

      showAlert(
        error.response?.data?.message || "Error creating groupage item",
      );
    }
  };

  const handleEditItem = (item) => {
    setEditMode(true);

    setFormData({
      id: item.id,
      categories_fr: item.categories_fr || "",
      categories_en: item.categories_en || "",
      object_fr: item.object_fr || "",
      object_en: item.object_en || "",
      volume: item.volume ?? "",
      price: item.price ?? "",
    });

    setShowAddModal(true);
  };

  const handleUpdateItem = async () => {
    if (!formData.id) {
      showAlert("Item ID is missing");

      return;
    }

    if (
      !formData.categories_fr ||
      !formData.categories_en ||
      !formData.object_fr ||
      !formData.object_en ||
      formData.volume === ""
    ) {
      showAlert("Please fill all required fields");

      return;
    }

    try {
      const response = await axios.patch(
        `${port}/s_admin/groupage_items/update/${formData.id}`,
        {
          categories_fr: formData.categories_fr,
          categories_en: formData.categories_en,
          object_fr: formData.object_fr,
          object_en: formData.object_en,
          volume: Number(formData.volume),
        },
        {
          headers: {
            Authorization: token,
          },
        },
      );

      console.log(response);

      if (response.data.status) {
        showAlert(response.data.message);

        closeAddModal();

        setSelectedItem(null);

        fetchGroupageItems();
      } else {
        showAlert(response.data.message || "Unable to update item");
      }
    } catch (error) {
      console.log("Error updating groupage item:", error);

      showAlert(
        error.response?.data?.message || "Error updating groupage item",
      );
    }
  };

  const openDeleteModal = (item) => {
    setDeleteItem(item);

    setShowDeleteModal(true);
  };

  const cancelDelete = () => {
    setShowDeleteModal(false);

    setDeleteItem(null);
  };

  const confirmDelete = async () => {
    if (!deleteItem) return;

    try {
      const response = await axios.delete(
        `${port}/s_admin/groupage_items/delete/${deleteItem.id}`,
        {
          headers: {
            Authorization: token,
          },
        },
      );

      if (response.data.status) {
        showAlert(response.data.message);

        setShowDeleteModal(false);

        setDeleteItem(null);

        setSelectedItem(null);

        fetchGroupageItems();
      } else {
        showAlert(response.data.message || "Unable to delete item");
      }
    } catch (error) {
      console.log("Error deleting groupage item:", error);

      showAlert(
        error.response?.data?.message || "Error deleting groupage item",
      );

      setShowDeleteModal(false);
    }
  };

  const handleRowClick = (item) => {
    setSelectedItem(item);
  };

  const closeDetails = () => {
    setSelectedItem(null);
  };

  if (userRole !== "Sadmin") {
    return (
      <div className="bg-light p-4">
        <div className="alert alert-danger">
          Only super admin can access this page.
        </div>
      </div>
    );
  }

  return (
    <>
      <ConfirmationModal
        show={showDeleteModal}
        message={
          deleteItem
            ? `Are you sure you want to delete "${deleteItem.object_en}"?`
            : "Are you sure you want to delete this item?"
        }
        onConfirm={confirmDelete}
        onCancel={cancelDelete}
      />

      <div
        className="bg-light"
        style={{
          width: "100%",
          minHeight: "auto",
          overflow: "auto",
        }}
      >
        {isMobile ? (
          <div className="p-3">
            <div className="d-flex justify-content-between align-items-center mb-2">
              <label className="fs-3 mb-0">
                <span>Groupage Items</span>
              </label>

              <button className="btn btn-primary" onClick={openAddModal}>
                Add Item
              </button>
            </div>

            <div className="d-flex align-items-center mb-4">
              <span className="text-muted">
                {searchFromUrl
                  ? `Search results for "${searchFromUrl}"`
                  : "All Groupage Items"}
              </span>

              <span className="text-muted ms-1">Total: {totalItems}</span>
            </div>

            <form onSubmit={handleSearch} className="w-100">
              <div className="d-flex w-100 align-items-center gap-2">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search groupage items..."
                  value={searchInput}
                  onChange={(e) => setSearchInput(e.target.value)}
                />

                <button type="submit" className="btn btn-primary">
                  Search
                </button>
              </div>

              {/* {searchFromUrl && (
                                <div className="d-flex mt-2">
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        onClick={handleClearSearch}
                                    >
                                        Clear
                                    </button>
                                </div>
                            )} */}
            </form>
          </div>
        ) : (
          <div className="d-flex flex-wrap justify-content-between align-items-center rounded-1 p-3">
            <div className="d-flex justify-content-start">
              <label className="fs-3">
                <span>Groupage Items</span>
              </label>
            </div>

            <div className="d-flex justify-content-between align-items-center mb-3">
              <span className="text-muted">
                {searchFromUrl
                  ? `Search results for "${searchFromUrl}"`
                  : "All Groupage Items"}
              </span>

              <span className="text-muted">Total: {totalItems}</span>
            </div>

            <div className="d-flex align-items-center gap-2 mt-2 mt-md-0">
              <form
                onSubmit={handleSearch}
                className="d-flex align-items-center"
              >
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search groupage items..."
                  value={searchInput}
                  onChange={(e) => setSearchInput(e.target.value)}
                  style={{
                    width: "250px",
                  }}
                />

                <button type="submit" className="btn btn-primary ms-2">
                  Search
                </button>

                {/* {searchFromUrl && (
                                    <button
                                        type="button"
                                        className="btn btn-secondary ms-2"
                                        onClick={handleClearSearch}
                                    >
                                        Clear
                                    </button>
                                )} */}
              </form>

              <button className="btn btn-primary" onClick={openAddModal}>
                Add Item
              </button>
            </div>
          </div>
        )}

        <div
          className="d-flex mt-4 p-0 p-md-3 pb-0 mb-4 flex-column justify-content-start align-items-start m-2 m-md-5 rounded-1"
          style={{
            boxShadow: "0 0 5px 2px rgba(0, 0, 0, 0.15)",
          }}
        >
          <div
            className="table-responsive groupage-items-list"
            style={{
              width: "100%",
              overflowX: "auto",
            }}
          >
            {isMobile ? (
              <div className="groupage-items-mobile-container">
                {items && items.length > 0 ? (
                  items.map((item) => (
                    <div
                      key={item.id}
                      className="groupage-item-mobile-card"
                      onClick={() => setSelectedItem(item)}
                    >
                      <div className="d-flex justify-content-between align-items-start">
                        <div className="text-start">
                          <div className="d-flex gap-2 align-items-center">
                            <h5 className="mb-1">Item Id</h5>

                            <h5 className="mb-1 text-primary">#{item.id}</h5>
                          </div>

                          <h5 className="mb-2">{item.object_en || "-"}</h5>
                        </div>

                        <div
                          className="d-flex gap-2"
                          onClick={(e) => e.stopPropagation()}
                        >
                          <button
                            type="button"
                            className="groupage-mobile-edit-btn"
                            onClick={() => handleEditItem(item)}
                          >
                            <RiPencilFill />
                          </button>

                          <button
                            type="button"
                            className="groupage-mobile-delete-btn"
                            onClick={() => {
                              setDeleteItem(item);
                              setShowDeleteModal(true);
                            }}
                          >
                            <MdDelete />
                          </button>
                        </div>
                      </div>

                      <div className="d-flex flex-column align-items-start mt-2">
                        <h6>
                          Category: <span>{item.categories_en || "-"}</span>
                        </h6>

                        <h6>
                          Category FR:{" "}
                          <span>{item.categories_fr || "-"}</span>
                        </h6>

                        <h6>
                          Object FR: <span>{item.object_fr || "-"}</span>
                        </h6>

                        <h6>
                          Volume: <span>{item.volume ?? "-"} m³</span>
                        </h6>

                        <h6>
                          Price (€): <span>{item.price ?? "-"}</span>
                        </h6>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="text-center text-secondary py-4">
                    No Data Available
                  </div>
                )}
              </div>
            ) : (
              <table className="table table-hover">
                <thead>
                  <tr>
                    <th>
                      <h6>Category FR</h6>
                    </th>

                    <th>
                      <h6>Category EN</h6>
                    </th>

                    <th>
                      <h6>Object FR</h6>
                    </th>

                    <th>
                      <h6>Object EN</h6>
                    </th>

                    <th>
                      <h6>Volume</h6>
                    </th>

                    <th>
                      <h6>Price (€)</h6>
                    </th>

                    <th>
                      <h6>Actions</h6>
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {items && items.length > 0 ? (
                    items.map((item) => (
                      <tr
                        key={item.id}
                        onClick={() => handleRowClick(item)}
                        style={{
                          cursor: "pointer",
                        }}
                      >
                        <td className="text-secondary">
                          {item.categories_fr || "-"}
                        </td>

                        <td className="text-secondary">
                          {item.categories_en || "-"}
                        </td>

                        <td className="text-secondary">
                          {item.object_fr || "-"}
                        </td>

                        <td className="text-secondary">
                          {item.object_en || "-"}
                        </td>

                        <td className="text-secondary">{item.volume ?? "-"}</td>

                        <td className="text-secondary">{item.price ?? "-"}</td>

                        <td
                          className="text-secondary"
                          onClick={(e) => e.stopPropagation()}
                        >
                          <button
                            className="btn btn-sm btn-light text-primary pt-0 pb-0"
                            onClick={() => handleEditItem(item)}
                            style={{
                              fontSize: "1.5rem",
                            }}
                          >
                            <RiPencilFill />
                          </button>

                          <button
                            className="btn btn-sm btn-light text-danger pt-0 pb-0"
                            onClick={() => openDeleteModal(item)}
                            style={{
                              fontSize: "1.5rem",
                            }}
                          >
                            <MdDelete />
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7" className="text-secondary text-center">
                        No Data
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            )}
            {totalPages > 1 && (
              <div className="d-flex justify-content-center align-items-center mt-4 mb-4">
                <button
                  className="btn btn-primary"
                  onClick={() => {
                    const params = new URLSearchParams(searchParams);
                    params.set("page", String(Math.max(currentPage - 1, 1)));
                    setSearchParams(params);
                  }}
                  disabled={currentPage === 1}
                >
                  Previous
                </button>

                <span
                  style={{
                    fontSize: "16px",
                    margin: "0 10px",
                  }}
                >
                  Page {currentPage} of {totalPages}
                </span>

                <button
                  className="btn btn-primary"
                  onClick={() => {
                    const params = new URLSearchParams(searchParams);
                    params.set(
                      "page",
                      String(Math.min(currentPage + 1, totalPages)),
                    );
                    setSearchParams(params);
                  }}
                  disabled={currentPage === totalPages}
                >
                  Next
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      {showAddModal && (
        <div
          className="position-fixed bg-light p-4 shadow rounded"
          style={{
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "90%",
            maxWidth: "600px",
            maxHeight: "90vh",
            overflowY: "auto",
            zIndex: 1050,
          }}
        >
          <button
            className="btn-close position-absolute top-0 end-0 m-3"
            onClick={closeAddModal}
          ></button>

          <h4 className="mb-4 text-center">
            {editMode ? "Update Groupage Item" : "Add Groupage Item"}
          </h4>

          <div className="mb-3">
            <label className="form-label">Categories FR</label>

            <input
              type="text"
              className="form-control"
              name="categories_fr"
              value={formData.categories_fr}
              onChange={handleChange}
              placeholder="Enter French category"
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Categories EN</label>

            <input
              type="text"
              className="form-control"
              name="categories_en"
              value={formData.categories_en}
              onChange={handleChange}
              placeholder="Enter English category"
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Object FR</label>

            <input
              type="text"
              className="form-control"
              name="object_fr"
              value={formData.object_fr}
              onChange={handleChange}
              placeholder="Enter French object"
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Object EN</label>

            <input
              type="text"
              className="form-control"
              name="object_en"
              value={formData.object_en}
              onChange={handleChange}
              placeholder="Enter English object"
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Volume</label>

            <input
              type="number"
              className="form-control"
              name="volume"
              value={formData.volume}
              onChange={handleChange}
              placeholder="Enter volume"
              min="0"
              step="any"
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Price</label>

            <input
              type="number"
              className="form-control"
              name="price"
              value={formData.price}
              disabled
            />

            <small className="text-muted">
              Price is automatically calculated as Volume × 600
            </small>
          </div>

          <div className="d-flex justify-content-end gap-2 mt-4">
            <button className="btn btn-secondary" onClick={closeAddModal}>
              Cancel
            </button>

            {!editMode ? (
              <button className="btn btn-primary" onClick={handleAddItem}>
                Add
              </button>
            ) : (
              <button className="btn btn-primary" onClick={handleUpdateItem}>
                Update
              </button>
            )}
          </div>
        </div>
      )}

      {selectedItem && (
        <div
          className="position-fixed bg-light p-4 shadow rounded"
          style={{
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "90%",
            maxWidth: "600px",
            maxHeight: "90vh",
            overflowY: "auto",
            zIndex: 1040,
          }}
        >
          <button
            className="btn-close position-absolute top-0 end-0 m-3"
            onClick={closeDetails}
          ></button>

          <h4 className="mb-4 text-center">Groupage Item Details</h4>

          <div className="table-responsive">
            <table className="table">
              <tbody>
                <tr>
                  <th>Categories FR</th>
                  <td>{selectedItem.categories_fr || "-"}</td>
                </tr>

                <tr>
                  <th>Categories EN</th>
                  <td>{selectedItem.categories_en || "-"}</td>
                </tr>

                <tr>
                  <th>Object FR</th>
                  <td>{selectedItem.object_fr || "-"}</td>
                </tr>

                <tr>
                  <th>Object EN</th>
                  <td>{selectedItem.object_en || "-"}</td>
                </tr>

                <tr>
                  <th>Volume</th>
                  <td>{selectedItem.volume ?? "-"}</td>
                </tr>

                <tr>
                  <th>Price</th>
                  <td>{selectedItem.price ?? "-"}</td>
                </tr>

                <tr>
                  <th>Created At</th>
                  <td>
                    {selectedItem.create_at
                      ? new Date(selectedItem.create_at).toLocaleString()
                      : "-"}
                  </td>
                </tr>

                <tr>
                  <th>Updated At</th>
                  <td>
                    {selectedItem.updated_at
                      ? new Date(selectedItem.updated_at).toLocaleString()
                      : "-"}
                  </td>
                </tr>

                <tr>
                  <th>Updated By</th>
                  <td>{selectedItem.updated_by_email || "-"}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="d-flex justify-content-end mt-3">
            <button className="btn btn-secondary" onClick={closeDetails}>
              Close
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default Groupage_items;
